import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';
import type { TableQuery } from '../../../shared/components/generic-table/models/table-query.model';
import type { DashboardFilterOptions } from '../models/dashboard-filters.model';
import type { MatrixAnalyticsRow } from '../models/matrix-analytics.model';
import type { MatrixInvestigationRow } from '../models/matrix-investigation.model';
import type { MatrixTrackerCardData } from '../models/matrix-tracker-chart';
import type { MidasAiVideosCardData, TableDataResponse } from './dashboard-mock.service';

export interface DashboardDataService {
  getFilterOptions(): Observable<DashboardFilterOptions>;
  getMatrixAnalytics(query: TableQuery): Observable<TableDataResponse<MatrixAnalyticsRow>>;
  getPatientInvestigation(query: TableQuery): Observable<MatrixInvestigationRow[]>;
  getMatrixTrackerCardData(params: { organizationId: string; daysBack: string }): Observable<MatrixTrackerCardData>;
  getMidasAiVideosCardData(): Observable<MidasAiVideosCardData>;
}

export const DASHBOARD_DATA = new InjectionToken<DashboardDataService>('DASHBOARD_DATA');
